<template>
  <div class="helpdetail">
    <Menu :showDocMenu="setMenuZIndex" v-if="queryP !== 'app'" />
    <div class="srch_bx" :class="{ app: queryP == 'app' }">
      <img
        class="menu_icon"
        src="@/assets/helpcenter/fold@2x.png"
        alt=""
        @click="
          show = true;
          setMenuZIndex = true;
        "
      />
      <div class="put_bx">
        <img class="srch_icon" src="@/assets/helpcenter/search@2x.png" alt="" />
        <input
          ref="search_input"
          @input="searchInput"
          v-model="search_val"
          @click="getFocus"
          class="put"
          type="text"
          placeholder="搜索您的问题"
        />
      </div>
      <div class="search_res" v-if="search_res.length > 0">
        <p
          @click="tosrcres(item)"
          v-for="(item, index) in search_res"
          :key="index"
          class="item"
        >
          {{ item.title }}
        </p>
      </div>
      <div
        class="search_res search_res0"
        v-if="search_res.length == 0 && has_search"
      >
        抱歉，暂时没有您搜索的词条
      </div>
    </div>
    <div class="text_data" v-if="doc_info">
      <h3 class="doc_info_title" v-if="doc_info.title">{{ doc_info.title }}</h3>
      <markdown-it-vue
        class="md-body markdown-body"
        :content="doc_info.content"
      />
    </div>
    <div class="loading_bx" v-else :style="{ minHeight: '300px' }">
      <Loading />
    </div>
    <div class="useful_bx" v-if="doc_info">
      <p class="ub_title">以上内容对你是否有帮助？</p>
      <div class="ub_bx">
        <div
          class="ub_item ub_item0"
          :class="{ commened1: hasComment == 1 }"
          @click="setComnent(1)"
        >
          <img class="img1" src="@/assets/helpcenter/useful@2x.png" alt="" />
          <img class="img2" src="@/assets/helpcenter/useful2@2x.png" alt="" />
          <span>有帮助</span>
        </div>
        <div
          class="ub_item ub_item1"
          :class="{ commened1: hasComment == -1 }"
          @click="setComnent(-1)"
        >
          <img class="img1" src="@/assets/helpcenter/unuseful@2x.png" alt="" />
          <img class="img2" src="@/assets/helpcenter/unuseful2@2x.png" alt="" />
          <span>无帮助</span>
        </div>
      </div>
    </div>
    <Popup
      @closed="popColose()"
      v-model="show"
      position="left"
      :style="{ width: '304px', height: '100%' }"
      overlay-class="dirList_bx"
    >
      <div v-if="dir_list.length > 0" class="d_menu_bx">
        <div class="dm_head">
          <p>问题解答</p>
          <img
            src="@/assets/helpcenter/close.png"
            alt=""
            @click="show = false"
          />
        </div>
        <div class="dm_line"></div>
        <div class="dm_cont">
          <div
            class="dir_item"
            v-for="(item, index) in dir_list"
            :key="item.id"
          >
            <div class="dir_item_title" @click="toggle(index)">
              <div class="dir_item_title_left">
                {{ item.order }} {{ item.title }}
              </div>
              <img
                :class="item.hide ? 'u' : 'd'"
                src="@/assets/helpcenter/dn@2x.png"
                alt=""
              />
            </div>
            <div v-if="!item.hide" class="dir_item_box">
              <div
                @click="getData(item2.id)"
                class="dir_item_list"
                :class="doc_info && doc_info.id == item2.id ? 'active' : ''"
                v-for="(item2, index2) in item.children"
                :key="index2"
              >
                {{ item.order }}.{{ item2.order }} {{ item2.title }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="d_loading_bx"><Loading /></div>
    </Popup>
    <Footer />
  </div>
</template>
<script>
import Menu from "@/components/menu";
import Footer from "@/components/footer";
import MarkdownItVue from "markdown-it-vue";
import "markdown-it-vue/dist/markdown-it-vue.css";
import { Popup, Loading } from "vant";
export default {
  components: {
    Menu,
    Footer,
    MarkdownItVue,
    Popup,
    Loading,
  },
  data() {
    return {
      doc_info: null,
      hasComment: 0,
      dir_list: [],
      key_words: [],
      doc_id: "",
      type: "",
      type_str: "",
      show: false,
      search_val: "",
      search_res: [],
      timer: null,
      has_search: false,
      setMenuZIndex: false,
      queryP: ''
    };
  },
  created() {
    this.getParams();
    this.queryP = this.$route.query.p || '';
  },
  methods: {
    tosrcres(item){
      this.search_val = '';
      this.search_res = [];
      this.has_search = false;
      this.$router.push({
        params: {
          type: `${
            item.type == 0
              ? 'questions'
              : item.type == 1
              ? 'solo'
              : 'enterprise'
          }`,
          id: item.id
        },
        query: {
          p: this.queryP
        }
      })
      this.getParams();
    },
    async getParams() {
      try {
        let _type = this.$route.params.type;
        if (_type == "questions") {
          this.type = 0;
          this.type_str = "questions";
        } else if (_type == "solo") {
          this.type = 1;
          this.type_str = "solo";
        } else if (_type == "enterprise") {
          this.type = 2;
          this.type_str = "enterprise";
        }
        this.doc_id = this.$route.params.id;

        let _res1 = await this.$serve.getDirList({
          type: this.type,
        });
        this.dir_list = _res1.data;

        this.doc_id = this.$route.params.id;
        if (this.doc_id == "index") {
          this.doc_id = this.dir_list[0].children[0].id;
        }
        this.getData(this.doc_id);
      } catch (error) {
        // console.error(1,error)
      }
    },
    toggle(index) {
      this.$set(
        this.dir_list[index],
        "hide",
        this.dir_list[index].hide ? false : true
      );
    },
    async getData(id) {
      window.scrollTo(0, 0);
      this.doc_id = id;
      this.show = false;
      let _res3 = await this.$serve.getDocDetail({
        id: id,
      });
      this.doc_info = _res3.data || "";
      this.search_res = [];
      this.has_search = false;
    },
    setComnent(val) {
      this.hasComment = val;
      this.$serve.setComment({
        id: this.doc_id,
        type: val,
      });
    },
    searchInput() {
      if (this.search_val.trim().length > 0) {
        this.delayTimer(0);
      } else {
        clearInterval(this.timer);
        this.search_res = [];
        this.has_search = false;
      }
    },
    //防抖
    delayTimer(i) {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        i++;
        if (i >= 2) {
          this.searchInfo();
          clearInterval(this.timer);
        }
      }, 500);
    },
    async searchInfo() {
      try {
        const res = await this.$serve.searchData({
          title: this.search_val,
        });
        // 过滤掉faq
        this.search_res = res.data.list.filter(item => item.type !== 3);
        this.has_search = true;
        // eslint-disable-next-line no-empty
      } catch (error) {}
    },
    selectWord(title) {
      this.search_val = title;
      this.searchInfo();
    },
    getFocus() {
      this.$refs.search_input.focus();
      this.searchInput();
    },
    popColose() {
      this.setMenuZIndex = false;
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
<style lang="less">
@import "~@/assets/style/markdown.less";
@import "~@/assets/style/markdownReset.less";
.helpdetail {
  position: relative;
  .srch_bx {
    position: fixed;
    left: 0;
    top: 45px;
    width: 100%;
    height: 68px;
    background: #ffffff;
    border-bottom: 1px solid #e6e8eb;
    padding-left: 24px;
    padding-right: 24px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    &.app {
      top: 0;
    }
    .menu_icon {
      width: 20px;
      height: 19px;
    }
    .put_bx {
      margin-left: 20px;
      display: flex;
      align-items: center;
      flex: 1;
      box-shadow: 0px 6px 15px 0px #f7f8fa;
      border-radius: 3px;
      border: 1px solid #c2c5cc;
      padding-left: 16px;
      padding-right: 16px;
      height: 40px;
      position: relative;
      .srch_icon {
        width: 20px;
        height: 20px;
      }
      .put {
        margin-left: 6px;
        background: none;
        outline: none;
        border: none;
        font-size: 16px;
        flex: 1;
        &:focus {
          border: none;
        }
        &::-webkit-input-placeholder {
          color: #cacccf;
        }
      }
    }
    .search_res {
      position: absolute;
      top: 68px;
      left: 0;
      width: 100%;
      padding: 6px 20px 6px 20px;
      box-sizing: border-box;
      background-color: #fff;
      border-bottom: 1px solid #c2c5cc;
      box-shadow: 0px 11px 20px 0px rgba(0, 0, 0, 0.2);
      z-index: 1;
      max-height: 320px;
      overflow: auto;
      .item {
        display: block;
        font-size: 14px;
        margin-bottom: 2px;
        padding-top: 6px;
        padding-bottom: 6px;
        -webkit-line-clamp: 1;
        height: 17px;
        cursor: pointer;
      }
    }
    .search_res0 {
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ccced4;
    }
  }
  .text_data {
    padding: 24px;
    padding-top: 92px;
    background: #fff;
    .doc_info_title {
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #0f1012;
      padding-bottom: 30px;
      border-bottom: 1px solid #e6e8eb;
    }
  }
  .useful_bx {
    padding-top: 30px;
    border-top: 1px solid #f2f3f5;
    padding-bottom: 55px;
    background: #fff;
    .ub_title {
      text-align: center;
      font-size: 14px;
      font-family: PingFangTC-Semibold, PingFangTC;
      font-weight: 600;
      color: #616369;
      margin-bottom: 30px;
    }
    .ub_bx {
      margin-top: 13px;
      display: flex;
      justify-content: center;
      align-items: center;
      .ub_item {
        margin-left: 10px;
        margin-right: 10px;
        width: 96px;
        height: 40px;
        background: #f7f8fa;
        border-radius: 7px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 16px;
          height: 16px;
        }
        span {
          margin-left: 9px;
          font-size: 14px;
          font-family: PingFangTC-Regular, PingFangTC;
          font-weight: 400;
          color: #7f7f7f;
        }
        .img2 {
          display: none;
        }
        &.commened1 {
          background: #0b80fe;
          span {
            color: #fff;
          }
          .img1 {
            display: none;
          }
          .img2 {
            display: block;
          }
        }
      }
    }
  }
  .dirList_bx {
    z-index: 9999;
  }
  .loading_bx {
    padding-top: 92px;
    text-align: center;
    display: flex;
    align-items: center;
    background: #fff;
    justify-content: center;
  }
  .d_loading_bx {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
  .d_menu_bx {
    display: flex;
    flex-direction: column;
    height: 100%;
    .dm_head {
      width: 100%;
      padding: 24px;
      padding-bottom: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      margin-top: 50px;
      p {
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d232b;
      }
      img {
        width: 20px;
        height: 20px;
      }
    }
    .dm_line {
      margin-left: 24px;
      margin-right: 24px;
      height: 1px;
      background: #ccced4;
    }
    .dm_cont {
      padding-left: 24px;
      flex: 1;
      overflow-y: auto;
      .dir_item_title {
        margin-top: 10px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #1d232b;
        img {
          width: 10px;
          height: auto;
          margin-right: 30px;
          &.u {
            -ms-transform: rotate(90deg); /* IE 9 */
            -webkit-transform: rotate(90deg); /* Safari and Chrome */
            transform: rotate(190deg);
            transition: all 0.5s;
          }
        }
      }
      .dir_item_list {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #7f7f7f;
        &.active {
          color: #0b80fe;
        }
      }
    }
  }
  .md-body {
    padding-top: 30px;
  }
}
</style>
